import apiClient from "..";

export const getIndex = () => {
  return apiClient.get(`indexes`);
};

export const performanceDuration = () => {
  return apiClient.get(`portfolioperformancedurations`);
};

export const getAssetClasses = ({ advisor, familyId }) => {
  const url = `families/${familyId}/portfolioassetclasses`;
  return apiClient.get(url, {
    params: {
      advisor,
    },
  });
};

export const getAssetClassesClient = ({ advisor, clientId }) => {
  const url = `clients/${clientId}/portfolioassetclasses`;
  return apiClient.get(url, {
    params: {
      advisor,
    },
  });
};

export const getDataPerAsset = ({ familyId, classId, duration, advisor }) => {
  const url = `families/${familyId}/portfolioassetclasses/${classId?.id}/absoluteReturnperformance`;
  return apiClient.get(url, {
    params: {
      duration: duration,
      advisortype: advisor,
    },
  });
};

export const getDataPerAssetClient = ({
  clientId,
  classId,
  duration,
  advisor,
}) => {
  const url = `clients/${clientId}/portfolioassetclasses/${classId?.id}/absoluteReturnperformance`;
  return apiClient.get(url, {
    params: {
      duration: duration,
      advisortype: advisor,
    },
  });
};

export const perVehicle = ({
  duration,
  advisor,
  sentClass,
  assetClass,
  familyId,
}) => {
  const url = `families/${familyId}/portfolioassetclasses/${
    sentClass !== undefined ? sentClass.id : assetClass?.id
  }/instrumentvehicles/performance`;

  return apiClient.get(url, {
    params: {
      duration: duration,
      advisortype: advisor,
    },
  });
};

export const perVehicleClient = ({
  duration,
  advisor,
  sentClass,
  assetClass,
  clientId,
}) => {
  const url = `clients/${clientId}/portfolioassetclasses/${
    sentClass !== undefined ? sentClass.id : assetClass?.id
  }/instrumentvehicles/performance`;

  return apiClient.get(url, {
    params: {
      duration: duration,
      advisortype: advisor,
    },
  });
};

export const benchMarkData = ({ index, selectedDuration, duration }) => {
  const url = `indexes/${index}/performance`;
  return apiClient.get(url, {
    params: {
      duration: duration === undefined ? selectedDuration : duration,
    },
  });
};

export const secondPageData = ({
  id,
  isFamily,
  Duration,
  advisor,
  assetClassId,
  subAssetClassId,
}) => {
  const url = `${isFamily}/${id}/portfolioassetclasses/${assetClassId}/instrumentvehicles/${subAssetClassId}/instruments/performance`;
  return apiClient.get(url, {
    params: {
      Duration,
      advisortype: advisor,
    },
  });
};

export const secPageReturns = ({
  isFamily,
  id,
  assetClassId,
  subAssetClassId,
  duration,
  advisor,
}) => {
  const url = `${isFamily}/${id}/portfolioassetclasses/${assetClassId}/instrumentvehicles/${subAssetClassId}/performance`;
  return apiClient.get(url, {
    params: {
      duration,
      advisor,
    },
  });
};

export const getTransactionDetails = ({
  isFamily,
  id,
  assetClassId,
  subAssetClassId,
  folioId,
  advisor,
}) => {
  const url = `${isFamily}/${id}/portfolio/assetclasses/${assetClassId}/instrumentvehicles/${subAssetClassId}/instruments/returns`;
  return apiClient.get(url, {
    params: {
      SubMeasureInstrumentId: folioId,
      advisortype: advisor,
    },
  });
};

export const getTransaction = ({ isFamily, id, measureId, folioId }) => {
  const url = `${isFamily}/${id}/portfolio/instruments/${measureId}/transactions`;
  return apiClient.get(url, {
    params: {
      isInfinity: 0,
      folioNumber: folioId,
    },
  });
};

export const derivativeProfile = (payload) => {
  const url = `GetDerivativeProfile`;
  const params = {
    ...payload,
    flag_promoterholding: "0",
    viewflag: "1",
  };
  return apiClient.get(url, { params });
};

export const derivativeProfileDetails = (payload) => {
  const url = `GetDerivativeProfileDetails`;
  const params = {
    ...payload,
    flag_promoterholding: "0",
    viewflag: "1",
    assetclassid: `6`,
    vehicleid: `16`,
  };
  return apiClient.get(url, { params });
};

export const derivativeFilter = (
  payload
  //   {
  //   familyId,
  //   user_id,
  //   showStock,
  //   duration,
  //   advisor,
  //   returntype,
  //   dateObj,
  //   transactiontype,
  //   byoptiontype,
  // }
) => {
  const url = `GetDerivativeInstrumentDetails`;
  const params = {
    ...payload,
    assetClassId: "6",
    vehicleid: "16",
    familymemberlist: "",
  };

  // params: {
  //   family_id: familyId,
  //   user_id,
  //   showmestockflag: showStock,
  //   assetClassId: "6",
  //   vehicleid: "16",
  //   duration: duration !== undefined ? duration : "ITD",
  //   advisor,
  //   returntype,
  //   fromdate: dateObj.from,
  //   toDate: dateObj.to,
  //   transactiontype,
  //   byoptiontype,
  //   familymemberlist: "",
  // },

  return apiClient.get(url, { params });
};

export const customData = ({
  subUrl,
  isFam,
  fromdate,
  todate,
  assetclassid,
  accounttype,
}) => {
  const url = `${subUrl}/${
    isFam ? "GetFamilyPerformanceDetails" : "GetClientPerformanceDetails"
  }`;

  if (subUrl.length > 20) {
    return apiClient.get(subUrl);
  } else {
    return apiClient.get(url, {
      params: {
        fromdate,
        todate,
        assetclassid,
        accounttype,
      },
    });
  }
};

export const customBenchMark = ({ fromdate, todate, indextypeid }) => {
  const url = `GetPerformanceBenchMark`;

  return apiClient.get(url, {
    params: {
      fromdate,
      todate,
      indextypeid,
    },
  });
};

export const events = () => {
  const url = `GetPerformanceEvents`;
  return apiClient.get(url);
};

export const submitEvents = ({ eventid }) => {
  const url = `GetPerformanceEvents`;

  return apiClient.get(url, {
    params: {
      eventid,
    },
  });
};

export const getCustomExcel = ({
  subUrl,
  isFam,
  fromdate,
  todate,
  accounttype,
  Exceldata = 1,
}) => {
  const url = `${subUrl}/${
    isFam ? "GetFamilyPerformanceDetails" : "GetClientPerformanceDetails"
  }`;
  return apiClient.get(url, {
    params: {
      fromdate,
      todate,
      accounttype,
      Exceldata,
    },
  });
};
